import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RoleGuard } from '../core/guards/role-guard/role-guard.guard';
import { UserType } from '../models/enums/user-type.enum';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { ServerErrorComponent } from './server-error/server-error.component';
import { SettingComponent } from './setting/setting.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { FeaturesComponent } from './features.component';
import { FinanceComponent } from './finance/finance/finance.component';
const routes: Routes = [
  {
    path: '',
    component: FeaturesComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',
        component: HomeComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin, UserType.Supervisor],
        },
      },
      { path: 'NotFound', component: NotFoundComponent },
      { path: 'ServerError', component: ServerErrorComponent },
      {
        path: 'setting',
        component: SettingComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'notifications',
        component: NotificationsComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./orders/orders.module').then((m) => m.OrdersModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [
            UserType.Admin,
            UserType.Assistant,
            UserType.Supervisor,
            UserType.OrderDataEntry,
            UserType.SupervisorQC,
            UserType.QC,
            UserType.AssignmentOffice,
          ],
        },
      },
      {
        path: 'finance',
        component: FinanceComponent,
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.FINANCE],
        },
      },
      {
        path: 'coupons',
        loadChildren: () =>
          import('./copoun/copoun.module').then((m) => m.CopounModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'notification-center',
        loadChildren: () =>
          import('./notification-center/notification-center.module').then(
            (m) => m.NotificationCenterModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'customers',
        loadChildren: () =>
          import('./customers/customers.module').then((m) => m.CustomersModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin, UserType.Supervisor],
        },
      },
      {
        path: 'inspectors',
        loadChildren: () =>
          import('./inspectors/inspectors.module').then(
            (m) => m.InspectorsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [
            UserType.Admin,
            UserType.Supervisor,
            UserType.InspectorActivationOffice,
          ],
        },
      },
      {
        path: 'sopra',
        loadChildren: () =>
          import('./sopra/exsep.module').then((m) => m.ExsepModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'pricing',
        loadChildren: () =>
          import('./pricing/pricing.module').then((m) => m.PricingModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'whats-new',
        loadChildren: () =>
          import('./whats-new/whats-new.module').then((m) => m.WhatsNewModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'projects',
        loadChildren: () =>
          import('./projects/projects.module').then((m) => m.ProjectsModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [
            UserType.Admin,
            UserType.Assistant,
            UserType.Supervisor,
            UserType.InspectorActivationOffice,
            UserType.OrderDataEntry,
            UserType.AssignmentOffice,
            UserType.QC,
            UserType.SupervisorQC,
          ],
        },
      },
      {
        path: 're-projects',
        loadChildren: () =>
          import('./re-projects/re-projects.module').then(
            (m) => m.ReProjectsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'company',
        loadChildren: () =>
          import('./companies/companies.module').then(
            (m) => m.CompaniessModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'markting',
        loadChildren: () =>
          import('./sms-campings/sms-campings.module').then(
            (m) => m.SmsCampingsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Markting],
        },
      },
      {
        path: 'services',
        loadChildren: () =>
          import('./ayen-services/services.module').then(
            (m) => m.ServicesModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin, UserType.Markting],
        },
      },
      {
        path: 'qc',
        loadChildren: () => import('./qc/qc.module').then((m) => m.QcModule),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'property-units',
        loadChildren: () =>
          import('./property-units/property-units.module').then(
            (m) => m.PropertyUnitsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin, UserType.Supervisor],
        },
      },
      {
        path: 'evaluations-management',
        loadChildren: () =>
          import('./evaluations-management/evaluations-management.module').then(
            (m) => m.EvaluationsManagementModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'capabilities',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./capabilities/pages/capability-list/capability-list.component').then(
                (m) => m.CapabilityListComponent,
              ),
          },
          {
            path: 'details/new',
            loadComponent: () =>
              import('./capabilities/pages/capability-details/capability-details.component').then(
                (m) => m.CapabilityDetailsComponent,
              ),
          },
          {
            path: 'details/:id',
            loadComponent: () =>
              import('./capabilities/pages/capability-details/capability-details.component').then(
                (m) => m.CapabilityDetailsComponent,
              ),
          },
        ],
      },
      {
        path: 'community',
        loadChildren: () =>
          import('./community/community.module').then((m) => m.CommunityModule),
      },
      {
        path: 'service-tags',
        loadChildren: () =>
          import('./service-tags/service-tags.module').then(
            (m) => m.ServiceTagsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
      {
        path: 'service-tags',
        loadChildren: () =>
          import('./service-tags/service-tags.module').then(
            (m) => m.ServiceTagsModule,
          ),
        canActivate: [RoleGuard],
        data: {
          expectedRole: [UserType.Admin],
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FeaturesRoutingModule {}
